import { SessionServerSelectors } from '~selectors/SessionInfoSelectors';
import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '~src/flow/utils/FlowTaskActionUtils';

import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskChangePriority } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskChangePriorityAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const ignoreExtractTaskPriority: boolean =  SessionServerSelectors.ignoreExtractTaskPriority(state);

    return !ignoreExtractTaskPriority && userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangePriority(targetItems)
};
